import React from 'react'
import styled from 'styled-components'
import { SeverityLevel } from '@microsoft/applicationinsights-web'

import { logTrace } from '../../Global/App/ApplicationInsights'
import NextDeparture from '../NextDeparture/NextDeparture'

const NextUp: React.FC<{
    departure: any
}> = ({ departure }) => {
    if (!departure) {
        logTrace('departure not defined in NextUp component', SeverityLevel.Warning)
        return null // TODO: Return error page?
    }

    return (
        <Container>
            <NextDeparture
                departureTime={departure.departureTime}
                departureDay={departure.departureDayOfWeek}
                next="Next up"
                half={false}
            />
        </Container>
    )
}

export default NextUp

const Container = styled.div`
    position: relative;
    height: 100%;
    width: 100%;
    overflow: hidden;
`
